import React from 'react'
import { Button, Form } from 'react-bootstrap'
import styles from './SearchForm.module.scss'
import { ChevronRight } from 'react-bootstrap-icons'
export default function SearchForm() {
    return (
        <Form className={`${styles.form}`}>
            <div className={`${styles.title}`}>
                Search Documents
            </div>
            <div className={`${styles.description}`}>
                Browse through this collection or use our advanced search to look for particular items of interest. Provide as many details such as dates, titles and key words for better results.
            </div>
            <Form.Group className={`${styles.formGroup} mb-3`} controlId="formBasicPassword">
                <Form.Control type="input" />
            </Form.Group>
            <Button variant="primary" type="submit" className={`${styles.btn}`}>
                <ChevronRight className={`${styles.icon}`} />
                SEARCH
            </Button>
        </Form>
    )
}
